import React from "react";
import Button from "react-bootstrap/Button";
import { useCart } from "./CartContext";
import "../../styles.css";

const ClearCartButton = () => {
  const { clearCart } = useCart();

  const handleClearCart = () => {
    clearCart();
  };

  return (
    <Button onClick={handleClearCart} className="clearcart-button">
      Clear Cart
    </Button>
  );
};

export default ClearCartButton;
